<template>
  <div>
    <v-card :loading="loading" elevation="2" class="p-5">
      <Lynx-Title text="Tipo de atividade" />

      <div>
        <Lynx-Label label="Tipo" />
        <Lynx-Input
          v-model="form.nome"
          placeholder="Digite o nome do tipo atividade"
        />
      </div>

      <div>
        <Lynx-Label label="Descrição" />
        <Lynx-Input
          v-model="form.descricao"
          placeholder="Digite a descrição do tipo atividade"
        />
      </div>
      <div class="flex justify-end">
        <b-button
          :disabled="loading"
          @click.native="confirm(listaCampos == null ? 'cria' : 'edita')"
          type="is-primary"
          class="mt-4"
          >{{ listaCampos == null ? "Criar" : "Atualizar" }}</b-button
        >
      </div>
      <b-button
        :disabled="loading"
        @click.native="$emit('hideModalTipoParcelamento')"
        type="is-danger"
        class="mt-4"
        >Cancelar</b-button
      >
    </v-card>
  </div>
</template>

  <script>
import { hasRole } from "@/utils/can";
import Treeselect from "@riophae/vue-treeselect";

export default {
  components: { Treeselect },
  props: {
    listaCampos: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        nome: null,
        descricao: null,
      },
      loading: false,
    };
  },
  computed: {
    mensagem_alert() {
      return this.$store.state.tipoParcelamento.mensagem_alert;
    },
  },
  watch: {},
  created() {
    this.preexerCampos();
  },
  methods: {
    hasRole,
    async confirm(tipo) {
      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` um tipo de parcelamento no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
        },
      });
    },

    async create() {
      this.loading = true;
      await this.$store
        .dispatch("tipoParcelamento/create_tipo_parcelamento", this.form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.$emit("hideModalTipoParcelamento");
        })
        .catch((error) => this.$snack.error(mensagem_alert.message))
        .finally(() => (this.loading = false));
    },

    async update() {
      this.loading = true;
      await this.$store
        .dispatch("tipoParcelamento/update_tipo_parcelamento", this.form)

        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.$emit("hideModalTipoParcelamento");
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));
    },
    preexerCampos() {
      if (this.listaCampos != null) {
        this.form = {
          id: this.listaCampos.id,
          nome: this.listaCampos.nome,
          descricao: this.listaCampos.descricao,
        };
      }
    },
  },
};
</script>
